import './QuickAccessViewButton.scss';

import { AppSwitherIcon, StackIcon } from '@ui/icons';
import { AuditOutlined, TagOutlined, UnorderedListOutlined } from '@ant-design/icons';
import {
	ComplianceCategory,
	DataDictionaryViewReference,
	DataSecurityApplicationReference,
	SonarTag
} from '@sonar-software/sonar-core';
import { getSonarObjectTypeFromId, getSonarObjectTypeLabel } from '@sonar-software/sonar-ts-lib';
import React, { useMemo } from 'react';
import { useApplicationReference, useCustomViews, useTagReference } from '@hooks';

const getViewType = (view?: DataDictionaryViewReference, tag?: SonarTag, app?: DataSecurityApplicationReference) => {
	switch (true) {
	case Boolean(view?.sonarObjectId):
		return <><StackIcon /> { view?.sonarObjectName }</>;
	case Boolean(view?.sonarObjectTypeId):
		const sonarObjectType = view?.sonarObjectTypeId ? getSonarObjectTypeFromId(view?.sonarObjectTypeId) : undefined;

		return <><UnorderedListOutlined /> { getSonarObjectTypeLabel(sonarObjectType) }</>;
	case Boolean(view?.tagId):
		return <><TagOutlined /> { tag?.name }</>;
	case Boolean(view?.applicationId):
		return <><AppSwitherIcon /> { app?.name }</>;
	case Number.isInteger(view?.complianceCategory):
		return <><AuditOutlined /> { ComplianceCategory[ view?.complianceCategory ?? 0 ] }</>;
	default:
		return null;
	}
};

export interface QuickAccessViewButtonProps {
	viewId: number
}

export const QuickAccessViewButton: React.FC<QuickAccessViewButtonProps> = ({ viewId }) => {
	const views = useCustomViews();
	const view = useMemo(() => views.find((found) => found.id === viewId), [ views, viewId ]);
	const tag = useTagReference(view?.tagId ?? -1);
	const app = useApplicationReference(view?.applicationId ?? -1);
	const viewType = useMemo(() => getViewType(view, tag, app), [ view, tag, app ]);

	return (
		<div className='quick-access-view-button'>
			<div className='view-name'>{ view?.name }</div>
			<div className='view-type'>{ viewType }</div>
		</div>
	);
};

